import { h } from 'preact';

import Grid from '@mui/material/Grid';

import LazyInpUrlIssueDetail from './lazyUrlIssueDetail.jsx';

export default function LazyInpUrlIssueDetails(_props) {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <LazyInpUrlIssueDetail />
      </Grid>
    </Grid>
  );
}
